import React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const RequestTableHeadHomePage = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell></TableCell>
                <TableCell sx={styles.defaultTextStyle}>Marka i Model</TableCell>
                <TableCell sx={styles.defaultTextStyle}>Ističe za</TableCell>
                <TableCell sx={styles.defaultTextStyle}>Naslov zahteva</TableCell>
                <TableCell sx={styles.defaultTextStyle}>Opis</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>

            </TableRow>
        </TableHead>
    );
};

export default RequestTableHeadHomePage;

const styles = {
    logoCell: {
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "24px",
        color: "rgba(0,0,0,0.87)",
    },
    defaultTextStyle: {
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "24px",
        color: "rgba(0,0,0,0.87)",
    },
};
